import styles from './MatchRow.module.css';
import { Badge } from './Badge.jsx';
import { SplitBar } from './SplitBar.jsx';
import { Button } from './Button.jsx';

/**
 * A compact forecast card: league, confidence, the two teams, the split bar,
 * and the verdict line. This is the Top Picks list row and the dashboard tile.
 *
 * When `locked` is true the content is blurred behind an upgrade prompt — the
 * shape of the pick is visible, the numbers are not.
 */
export function MatchRow({
  league,
  confidence,
  confidenceLabel,
  homeTeam,
  awayTeam,
  homeProbability,
  winner = 'home',
  predictedWinner,
  kickoff,
  locked = false,
  lockMessage = 'Upgrade to see all picks',
  lockCta = 'Upgrade',
  onUnlock,
  className = '',
}) {
  const body = (
    <>
      <div className={styles.top}>
        <span className={styles.league}>{league}</span>
        {confidence && (
          <Badge tone={confidence} dot>
            {confidenceLabel || confidence}
          </Badge>
        )}
      </div>

      <div className={styles.teams}>
        <span>{homeTeam}</span>
        <span>{awayTeam}</span>
      </div>

      <SplitBar
        homeProbability={homeProbability}
        winner={winner}
        size="md"
        homeLabel={homeTeam}
        awayLabel={awayTeam}
      />

      <div className={styles.verdict}>
        <span>
          Predicted · <b>{predictedWinner}</b>
        </span>
        {kickoff && <span>{kickoff}</span>}
      </div>
    </>
  );

  if (!locked) {
    return <div className={`${styles.row} ${className}`}>{body}</div>;
  }

  return (
    <div className={`${styles.row} ${styles.gated} ${className}`}>
      <div className={styles.blur} aria-hidden="true">
        {body}
      </div>
      <div className={styles.gate}>
        <span className={styles.lock} aria-hidden="true">
          🔒
        </span>
        <p>{lockMessage}</p>
        <Button size="sm" onClick={onUnlock}>
          {lockCta}
        </Button>
      </div>
    </div>
  );
}
